import { FormattedMessage } from 'react-intl';

interface CountdownProps {
  remainingTimeInSeconds: number;
}

export function Countdown({ remainingTimeInSeconds }: CountdownProps) {
  return (
    <div className="d-flex align-items-end">
      <div>
        <span className="remaining-time">
          <FormattedMessage id="sidePanel.countdown.seconds" values={{ value: remainingTimeInSeconds }} />
        </span>
        <i className="icon ms-2">timelapse</i>
      </div>
    </div>
  );
}
